import { commonActions, appServiceLines } from '@codametrix/ui-common';
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';

const { Case } = commonActions;

type caseAndCurrentProcess = {
  caseDetail: CMxAPI.Case;
  processId: number;
};

type BPMStepIds = {
  caseId: number | string;
  processInstanceId: number | string;
};

const bpmTasksAvailable = createAction<Record<string, CMxAPI.BPMStep[]>>(
  Case.BPM_EVIDENCE
);

const caseDetailAvailable = createAction<caseAndCurrentProcess>(Case.DETAIL);

const activeProcessId = createAction<number>(Case.SET_ACTIVE_PROCESS_ID);

const ignoreEvidence = createAction<boolean>(Case.IGNORE_EVIDENCE);

const getBPMDetails = createAsyncThunk(Case.DETAIL, async (
  step: BPMStepIds,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  const url = new URL(window.location.toString());
  const serviceLine = url.searchParams.get('serviceLine') ?? '';
  let serviceLineConfig = appServiceLines.determineServiceLineConfig({
    name: serviceLine,
    caseIdentifier: step.caseId?.toString()
  });

  const caseParams = new URLSearchParams(serviceLineConfig.caseDetailParms);

  const expandedCaseDetail: CMxAPI.Case = await api<CMxAPI.Case>({
    endpoint: `${serviceLineConfig.path}/caseinstance/${
      step.caseId
    }/details/${serviceLineConfig.caseDetailVersion}?${caseParams.toString()}`
  });

  const processId =
    typeof step.processInstanceId === 'string'
      ? parseInt(step.processInstanceId)
      : step.processInstanceId;

  const caseAndProcessId = {
    caseDetail: expandedCaseDetail,
    processId: processId
  };

  dispatch(caseDetailAvailable(caseAndProcessId));

  if (!serviceLineConfig.ignoreEvidence) {
    const evidence: Record<string, CMxAPI.BPMStep[]> = await api<
      Record<string, CMxAPI.BPMStep[]>
    >({
      endpoint: `${serviceLineConfig.path}/caseinstance/${step.caseId}/v1/evidence/process`
    });

    dispatch(bpmTasksAvailable(evidence));
  }

  dispatch(ignoreEvidence(serviceLineConfig.ignoreEvidence ?? false));
});

export {
  bpmTasksAvailable,
  activeProcessId,
  getBPMDetails,
  caseDetailAvailable,
  ignoreEvidence
};
